<template>
  <el-dropdown class="dropdown-user d-flex align-items-center dropdown-user-link  pe-0 dropdown-menu-right" size="large"
    type="primary" placement="bottom-end" style="text-decoration: none; list-style: none;" trigger="click">


    <section class="d-flex data-user" :class="{ 'is-logged': is_loggin }">

      <div class="d-none d-md-flex flex-column  user-nav align-items-end justify-content-center me-1  text-black"
        v-if="is_loggin">
        <p class="mb-0 text-end  lh-1 fs-3" :class="{ 'text-black': isPublic, 'text-white': !isPublic }">
          {{ usuario.nombre }}
        </p>

        <small class="text-end lh-sm fst-normal fw-bolder " :class="{ 'text-black': isPublic, 'text-white': !isPublic }"
          style="font-size:9pt">
          {{ usuario.rol ? usuario.rol.nombre : '' }}
        </small>

      </div>
      <avatar v-if="is_loggin" :src="usuario.id ? usuario.avatar : AvatarDefault" :sameBorder="false"
        :size="windowWidth < 420 ? 50 : 65" :name="usuario.nombre" :status="conectado ? 'online' : 'offline'"
        style="text-decoration: none; list-style: none;" />
      <article v-if="!is_loggin" class="d-flex gap-25 btn-dropdown">
        <b-button variant="outline-primary" size="sm" @click.stop="() => router.push({ name: 'registro' })"
          title="Regístrate" class="px-50 lh-0">
          <font-awesome-icon icon="fas fa-user-plus" class="me-0 me-md-25 d-md-none" />
          <strong class="d-none d-md-flex">Regístrate</strong>
        </b-button>

        <b-button variant="outline-secondary" size="sm" @click.stop="() => router.push({ name: 'login' })"
          title="Iniciar Sesión" class="px-50">
          <font-awesome-icon icon="fas fa-sign-in-alt" class="me-0 me-md-25 d-md-none" />
          <strong class="d-none d-md-flex text-nowrap">Iniciar</strong>
        </b-button>
      </article>
      <div class="badge-plan text-white" v-if="isCliente && usuario.plan_nombre && !isPublic"
        @click.stop="irSubscripcion">
        <strong class="text-white">{{ usuario.plan_nombre || 'S/D' }}</strong>
      </div>
    </section>


    <template #dropdown>
      <el-dropdown-menu>

        <el-dropdown-item v-if="is_user_anterior" @click="() => regresarAuthAnterior(regresoExitoso)" :button-props="{
          size: 'large'
        }">
          <avatar :src="is_loggin ? back_auth_user.avatar : ''" status="online" :name="back_auth_user.nombre"
            size="60" />
          <div class="user-nav ms-1 lh-0">
            <p class="user-name fw-bolder mb-0 lh-0 fs-5">
              {{ back_auth_user.nombre || '' }}
            </p>
            <span class="user-status">{{ back_auth_user.rol ? back_auth_user.rol.nombre : '' }}</span>
            <br>
            <em>Presione para Regresar a su cuenta</em>
          </div>
        </el-dropdown-item>

        <el-dropdown-item @click="() => router.push({ name: 'datos-pagos.list' })"
          v-if="is_loggin && isPromotor && $can('read', 'Datos para recibir pagos')">
          <font-awesome-icon icon="fa-money-bill" class="me-50 fs-6" />
          <span class="fs-6">Datos para recibir pagos</span>
        </el-dropdown-item>

        <el-dropdown-item @click="() => router.push({ name: 'home' })"
          v-if="is_loggin && is_layout_public && $can('read', 'Home')">
          <font-awesome-icon icon="home" class="me-50 fs-6" />
          <span class="fs-6">Tablero</span>
        </el-dropdown-item>

        <el-dropdown-item @click="() => router.push({ name: 'mi-perfil' })" v-if="is_loggin && $can('read', 'Perfil')">
          <font-awesome-icon icon="cog" class="me-50 fs-6" />
          <span class="fs-6">Mi Perfil</span>
        </el-dropdown-item>
        <el-dropdown-item @click="verPerfilPublico" v-if="is_loggin && $can('read', 'Perfil') && isCliente">
          <font-awesome-icon icon="user" class="me-50 fs-6" />
          <span class="fs-6">Perfil Público</span>
        </el-dropdown-item>

        <el-dropdown-item @click="() => router.push({ name: 'inbox' })" v-if="is_loggin && $can('read', 'Inbox')">
          <font-awesome-icon icon="message" class="me-50 fs-6" />
          <span class="fs-6">Inbox</span>
        </el-dropdown-item>

        <el-dropdown-item @click="logout" v-if="is_loggin">
          <font-awesome-icon icon="fas fa-sign-out-alt" class="me-50 fs-6" />
          <span class="fs-6">Cerrar sesión </span>
        </el-dropdown-item>

        <el-dropdown-item @click="() => router.push({ name: 'login' })" v-if="!is_loggin">
          <font-awesome-icon icon="fas fa-sign-in-alt" class="me-50" />
          <span>Login</span>
        </el-dropdown-item>
      </el-dropdown-menu>
    </template>

  </el-dropdown>

  <!-- <b-nav-item-dropdown toggle-class="d-flex align-items-center dropdown-user-link  pe-0 dropdown-menu-right"
    class="dropdown-user" size="lg">

  </b-nav-item-dropdown> -->
</template>

<script setup>
import useUtils from '@/composables/useUtils'
import useAuth from '@utils/useAuth'
import Locale from './Locale.vue'
import { getHomeRouteForLoggedInUser } from '@/auth/utils'
import ToastificationContent from '@/components/toastification/ToastificationContent.vue'
import AvatarDefault from '@images/default.jpg';
import useUsuarioStore from '@/store/usuario';
import useAppStore from '@/store/app';

const props = defineProps({
  isPublic: {
    type: Boolean,
    default: false
  }
});

const {
  loading,
  is_layout_public
} = useUtils();

const router = useRouter()
const usuario_store = useUsuarioStore();
const app_store = useAppStore();

const { usuario, isCliente, isPromotor } = storeToRefs(usuario_store);
const { windowWidth } = storeToRefs(app_store)

const {
  logout,
  is_loggin,
  is_user_anterior,
  regresarAuthAnterior,
  back_auth_user,
  conectado,
} = useAuth();

const showPerfilPublico = inject('showPerfilPublico');
const slug_autor = inject('slug_autor');

const rolName = computed(() => usuario.value.rol ? usuario.value.rol.nombre : '')

const regresoExitoso = (resultado) => {
  if (resultado) {

    router.replace(getHomeRouteForLoggedInUser(usuario.value.rol.nombre))
      .then(() => {
        toast({
          component: ToastificationContent,
          props: {
            title: `Hola ${usuario.value.nombre || usuario.value.username}`,
            icon: 'fa-mug-hot',
            variant: 'success',
            text: `Has iniciado sesión correctamente como ${usuario.value.rol.nombre} ¡Ahora puedes empezar a explorar!`,
          },
        }, {
          position: 'bottom-right',
          timeout: 4000
        })
      })
      .catch(e => location.reload())
      .then(() => location.reload())

  } else {
    toast.error('No se puede regresar, inténte después')
  }

}


const irSubscripcion = () => {
  router.push({ name: 'subscripcion.list' })
}


const verPerfilPublico = () => {
  slug_autor.value = usuario.value.slug;
  showPerfilPublico.value = true;
}


</script>

<style lang="scss" scoped>
@use '@variables/variables' as *;

.dropdown-user {
  position: relative;
  background-color: transparent !important;

  // Indicador visual sutil para que el usuario sepa que es clickable
  .data-user {
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: .5rem;
    transition: transform .18s ease, box-shadow .18s ease;
  }

  // Aplicar animación sólo cuando el usuario está logueado
  .data-user.is-logged {
    // animación sutil e infinita para indicar interactividad
    animation: user-attention 2s ease-in-out infinite;
  }

  // Al pasar hover o focus mostramos una animación breve que comunica interactividad
  &:hover .data-user.is-logged,
  &:focus-within .data-user.is-logged {
    /* en hover/focus reemplazamos la animación base por una breve señal y elevamos ligeramente */
    animation: user-hover 0.6s cubic-bezier(.2, .8, .2, 1) 1;
    transform: translateY(-2px);
    // box-shadow: 0 6px 14px rgba(0,0,0,0.06);
  }

  // Reducir movimiento para usuarios que prefieren animaciones reducidas
  @media (prefers-reduced-motion: reduce) {
    .data-user {
      animation: none !important;
      transition: none !important;
    }
  }

  .badge-plan {
    position: absolute;
    background-color: $primary !important;
    top: -22px;
    right: 20px;
    width: fit-content;
    padding: 5px 15px;
    border-radius: 20px;
    height: fit-content;
    color: white;
    white-space: nowrap;
    cursor: pointer;

    &:hover {
      box-shadow: 0px 3px 5px 2px rgba(0, 0, 0, 0.5);
    }

    @media (min-width:620px) {
      top: -20px;
    }

    @media (min-width:768px) {
      right: 50px;
    }
  }

  .btn-dropdown {
    strong {
      font-family: 'JosefinSans-Regular';
    }
  }
}

// Keyframes
@keyframes user-attention {
  0% {
    transform: translateY(0) scale(1);
  }

  30% {
    transform: translateY(-6px) scale(1.02);
  }

  60% {
    transform: translateY(-2px) scale(1.01);
  }

  100% {
    transform: translateY(0) scale(1);
  }
}

@keyframes user-hover {
  0% {
    transform: translateY(0) scale(1);
  }

  30% {
    transform: translateY(-6px) scale(1.03);
  }

  60% {
    transform: translateY(2px) scale(0.995);
  }

  100% {
    transform: translateY(0) scale(1);
  }
}
</style>